import { environment } from './../../../../../../environments/environment';
import { map } from 'rxjs/operators';
import { OnInit, Inject, Component } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { VisitTypeDto } from "src/DTOs/Organisations/Models/VisitTypeDto";

@Component({
    selector: 'app-dentally-treatments-dialog',
    templateUrl: 'dentally-treatments.dialog.html',
    styleUrls: ['dentally-treatments.dialog.scss']
})
export class DentallyTreatmentsDialog implements OnInit {
    treatments:{code:string, name:string, selected:boolean}[];
    visitTypesDropDown:string[];

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<DentallyTreatmentsDialog>) {
        data.treatments.forEach(t => { t.selected = false })
        this.treatments = data.treatments;
        this.visitTypesDropDown = data.visitTypesDropDown;
    }

    ngOnInit(): void {

    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    allSelected: boolean = false;
    allDone: boolean = false;

    updateAllSelected() {
        this.allSelected = this.treatments != null && this.treatments.every(t => t.selected);
    }

    someSelected(): boolean {
        if (this.treatments == null)
            return false;

        return this.treatments.filter(t => t.selected).length > 0 && !this.allSelected;
    }

    setAll(selected: boolean) {
        this.allSelected = selected;
        if (this.treatments == null)
            return;
        this.treatments.forEach(t => t.selected = selected);
    }

    onVisitTypeSelect(moveTo: string) {
        this.allDone = true;
        const resultData = {
            itemCodes: this.treatments.filter(t=>t.selected).map(t=>t.code),
            moveTo: moveTo
        };
        setTimeout(() => { this.dialogRef.close(resultData); }, 300);
    }
}